module.exports = __webpack_public_path__ + "magnifying-glass-f2d5e83e7858cf2c585d1478c38466f3.svg";